<template>
  <div id="flame">
    <div>
      <div id="toolbar" class="ui menu">
        <a class="item">Acroファイル交換サービス</a>
        <div class="right menu">
          <div id="receiverMain-menu" class="ui dropdown item" @click="toggleMenu">
            {{username}}
            <i class="dropdown icon"></i>
            <div class="menu" :style="{display:!!openedMenu?'block':'none'}">
              <a id="receiverMain-logout" class="item" @click="logout">ログアウト</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="content">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      username: '',
      openedMenu: false
    }
  },
  created: function () {
    this.username = this.$store.state.receiver.username
  },
  methods: {
    logout: function () {
      this.$store.commit('receiver/clear')
      localStorage.removeItem('role')
      localStorage.removeItem('exchange_id')
      if (localStorage.getItem('loginType') === 'upload') {
        localStorage.removeItem('loginType')
        this.$router.push({ name: 'receiverUploadLogin' })
      } else {
        localStorage.removeItem('loginType')
        this.$router.push({ name: 'receiverDownloadLogin' })
      }
    },
    toggleMenu: function () {
      this.openedMenu = !this.openedMenu
    }
  }
}
</script>
<style>
#flame {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#content {
  flex: 1;
  padding: 20px 10px 20px 10px;
  height: calc(100vh - 44px);
  overflow: auto;
}
</style>
